<template>
    <div class="row">

        <div class="col-md-4 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('importir') }}

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-primary float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="referensiImportir()">
                            <i class="link-icon mdi mdi-book-open-page-variant"></i>
                            {{ $t("referensi") }}
                        </button>

                    </h6>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('nomor_identitas') }}



                        </label>


                        <div class="row">

                            <div class="col-sm-6">


                                <v-select :options="fetchTipeIdentitas" v-model="importirTipeIdentitas" label="label"
                                    return-object @input="(country) => updateImportirTipeIdentitas(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="this.importirTipeIdentitas == null || this.importirTipeIdentitas?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Jenis Entitas Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeJenisIdentitas">
                                    <div v-for="error in errors.kodeJenisIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-6">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, entitasImportir, 'nomorIdentitas')"
                                    v-model="entitasImportir.nomorIdentitas" maxlength="50" required>

                                    <div v-if="this.entitasImportir.nomorIdentitas == null || this.entitasImportir?.nomorIdentitas == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Entitas Kosong
                                        </div>
                                    </div>

                                <div v-if="errors.nomorIdentitas">
                                    <div v-for="error in errors.nomorIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>




                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('name') }} </label>


                        <input type="text" class="form-control" :id="this.$dynamicId()"
                            @input="forceUpper($event, entitasImportir, 'namaEntitas')"
                            v-model="entitasImportir.namaEntitas" maxlength="255" required>

                            <div v-if="this.entitasImportir.namaEntitas == null || this.entitasImportir?.namaEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Nama Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.namaEntitas">
                            <div v-for="error in errors.namaEntitas" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('alamat') }} </label>


                        <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('alamat')"
                            v-model="entitasImportir.alamatEntitas"
                            @input="forceUpper($event, entitasImportir, 'alamatEntitas')" rows="3"></textarea>

                            <div v-if="this.entitasImportir.alamatEntitas == null || this.entitasImportir?.alamatEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Alamat Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.alamatEntitas">
                            <div v-for="error in errors.alamatEntitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('api_nib') }} </label>


                        <div class="row">

                            <div class="col-sm-6">


                                <v-select :options="fetchkodeJenisApi" v-model="importirkodeJenisApi" label="label"
                                    return-object @input="(country) => updateImportirkodeJenisApi(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="this.importirkodeJenisApi == null || this.importirkodeJenisApi?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Jenis API Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeJenisApi">
                                    <div v-for="error in errors.kodeJenisApi" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-6">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, entitasImportir, 'nibEntitas')"
                                    v-model="entitasImportir.nibEntitas" maxlength="50" required>

                                    <div v-if="this.entitasImportir.nibEntitas == null || this.entitasImportir?.nibEntitas == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            NIB Kosong
                                        </div>
                                    </div>

                                <div v-if="errors.nibEntitas">
                                    <div v-for="error in errors.nibEntitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>




                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('status') }} </label>



                        <v-select :options="fetchstatusImportir" v-model="importirkodeStatus" label="code" return-object
                            @input="(country) => updateImportirkodeStatus(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.code }}
                            </template>
                        </v-select>

                        <div v-if="this.importirkodeStatus == null || this.importirkodeStatus?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Jenis API Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodeStatus">
                            <div v-for="error in errors.kodeStatus" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>


                </div>

            </div>


        </div>


        <div class="col-md-4 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('pemilik_barang') }}

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-primary float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="referensiPemilikBarang()">
                            <i class="link-icon mdi mdi-book-open-page-variant"></i>
                            {{ $t("referensi") }}
                        </button>

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-info float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="copyImportirToPemilikBarang()">
                            <i class="link-icon mdi mdi-content-copy"></i>
                            {{ $t("salin_importir") }}
                        </button>

                    </h6>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('nomor_identitas') }}



                        </label>


                        <div class="row">

                            <div class="col-sm-6">


                                <v-select :options="fetchTipeIdentitas" v-model="pemilikBarangTipeIdentitas" label="label"
                                    return-object @input="(country) => updatePemilikBarangTipeIdentitas(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="this.pemilikBarangTipeIdentitas == null || this.pemilikBarangTipeIdentitas?.code == ''">
                                            <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Jenis Entitas Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeJenisIdentitas">
                                    <div v-for="error in errors.kodeJenisIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-6">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, entitasPemilikBarang, 'nomorIdentitas')"
                                    v-model="entitasPemilikBarang.nomorIdentitas" maxlength="50" required>

                                    <div v-if="this.entitasPemilikBarang.nomorIdentitas == null || this.entitasPemilikBarang?.nomorIdentitas == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Entitas Kosong
                                        </div>
                                    </div>
                                <div v-if="errors.nomorIdentitas">
                                    <div v-for="error in errors.nomorIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>




                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('name') }} </label>


                        <input type="text" class="form-control" :id="this.$dynamicId()"
                            @input="forceUpper($event, entitasPemilikBarang, 'namaEntitas')"
                            v-model="entitasPemilikBarang.namaEntitas" maxlength="255" required>

                            <div v-if="this.entitasPemilikBarang.namaEntitas == null || this.entitasPemilikBarang?.namaEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Nama Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.namaEntitas">
                            <div v-for="error in errors.namaEntitas" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('alamat') }} </label>


                        <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('alamat')"
                            v-model="entitasPemilikBarang.alamatEntitas"
                            @input="forceUpper($event, entitasPemilikBarang, 'alamatEntitas')" rows="3"></textarea>

                            <div v-if="this.entitasPemilikBarang.alamatEntitas == null || this.entitasPemilikBarang?.alamatEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Alamat Entitas Kosong
                                </div>
                            </div>


                        <div v-if="errors.alamatEntitas">
                            <div v-for="error in errors.alamatEntitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>




                </div>

            </div>


        </div>


        <div class="col-md-4 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('npwp_pemusatan') }}

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-info float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="copyImportirToNpwpPemusatan()">
                            <i class="link-icon mdi mdi-content-copy"></i>
                            {{ $t("salin_importir") }}
                        </button>

                    </h6>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('nomor_identitas') }}



                        </label>


                        <div class="row">

                            <div class="col-sm-6">


                                <v-select :options="fetchTipeIdentitas" v-model="npwpPemusatanTipeIdentitas" label="label"
                                    return-object @input="(country) => updateNpwpPemusatanTipeIdentitas(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="this.npwpPemusatanTipeIdentitas == null || this.npwpPemusatanTipeIdentitas?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Jenis Entitas Kosong
                                    </div>
                                </div>

                                <div v-if="errors.kodeJenisIdentitas">
                                    <div v-for="error in errors.kodeJenisIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-6">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, entitasNpwpPemusatan, 'nomorIdentitas')"
                                    v-model="entitasNpwpPemusatan.nomorIdentitas" maxlength="50" required>

                                    <div v-if="this.entitasNpwpPemusatan.nomorIdentitas == null || this.entitasNpwpPemusatan?.nomorIdentitas == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Entitas Kosong
                                        </div>
                                    </div>

                                <div v-if="errors.nomorIdentitas">
                                    <div v-for="error in errors.nomorIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>




                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('name') }} </label>


                        <input type="text" class="form-control" :id="this.$dynamicId()"
                            @input="forceUpper($event, entitasNpwpPemusatan, 'namaEntitas')"
                            v-model="entitasNpwpPemusatan.namaEntitas" maxlength="255" required>

                            <div v-if="this.entitasNpwpPemusatan.namaEntitas == null || this.entitasNpwpPemusatan?.namaEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Nama Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.namaEntitas">
                            <div v-for="error in errors.namaEntitas" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('alamat') }} </label>


                        <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('alamat')"
                            v-model="entitasNpwpPemusatan.alamatEntitas"
                            @input="forceUpper($event, entitasNpwpPemusatan, 'alamatEntitas')" rows="3"></textarea>

                            <div v-if="this.entitasNpwpPemusatan.alamatEntitas == null || this.entitasNpwpPemusatan?.alamatEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Alamat Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.alamatEntitas">
                            <div v-for="error in errors.alamatEntitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>




                </div>

            </div>


        </div>


        <div class="col-md-4 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('pengirim') }}

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-primary float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="referensiPengirim()">
                            <i class="link-icon mdi mdi-book-open-page-variant"></i>
                            {{ $t("referensi") }}
                        </button>

                    </h6>


                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('name') }} </label>


                        <input type="text" class="form-control" :id="this.$dynamicId()"
                            @input="forceUpper($event, entitasPengirim, 'namaEntitas')"
                            v-model="entitasPengirim.namaEntitas" maxlength="255" required>

                            <div v-if="this.entitasPengirim.namaEntitas == null || this.entitasPengirim?.namaEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Nama Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.namaEntitas">
                            <div v-for="error in errors.namaEntitas" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('alamat') }} </label>


                        <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('alamat')"
                            v-model="entitasPengirim.alamatEntitas"
                            @input="forceUpper($event, entitasPengirim, 'alamatEntitas')" rows="3"></textarea>

                            <div v-if="this.entitasPengirim.alamatEntitas == null || this.entitasPengirim?.alamatEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Alamat Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.alamatEntitas">
                            <div v-for="error in errors.alamatEntitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>


                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('negara') }} </label>

                        <v-select :options="fetchkodeNegara" v-model="negaraPengirim" label="label" return-object
                            @input="(country) => updateNegaraPengirim(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                            </template>
                        </v-select>

                        <div v-if="this.negaraPengirim == null || this.negaraPengirim?.code == ''">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Negara Entitas Kosong
                            </div>
                        </div>

                        <div v-if="errors.kodeJenisIdentitas">
                            <div v-for="error in errors.kodeJenisIdentitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>




                    </div>


                </div>

            </div>


        </div>


        <div class="col-md-4 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('penjual') }}

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-info float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="copyPengirimToPenjual()">
                            <i class="link-icon mdi mdi-content-copy"></i>
                            {{ $t("salin_pengirim") }}
                        </button>

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-primary float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="referensiPenjual()">
                            <i class="link-icon mdi mdi-book-open-page-variant"></i>
                            {{ $t("referensi") }}
                        </button>

                    </h6>


                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('name') }} </label>


                        <input type="text" class="form-control" :id="this.$dynamicId()"
                            @input="forceUpper($event, entitasPenjual, 'namaEntitas')" v-model="entitasPenjual.namaEntitas"
                            maxlength="255" required>

                            <div v-if="this.entitasPenjual.namaEntitas == null || this.entitasPenjual?.namaEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Nama Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.namaEntitas">
                            <div v-for="error in errors.namaEntitas" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('alamat') }} </label>


                        <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('alamat')"
                            v-model="entitasPenjual.alamatEntitas"
                            @input="forceUpper($event, entitasPenjual, 'alamatEntitas')" rows="3"></textarea>

                            <div v-if="this.entitasPenjual.alamatEntitas == null || this.entitasPenjual?.alamatEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Alamat Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.alamatEntitas">
                            <div v-for="error in errors.alamatEntitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>


                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('negara') }} </label>

                        <v-select :options="fetchkodeNegara" v-model="negaraPenjual" label="label" return-object
                            @input="(country) => updateNegaraPenjual(country)">
                            <template slot="option" slot-scope="option">
                                {{ option.label }}
                            </template>
                        </v-select>

                        <div v-if="this.negaraPenjual == null || this.negaraPenjual?.code == ''">
                            <div class="alert alert-danger" style="padding:5px;"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                Jenis API Kosong
                            </div>
                        </div>


                        <div v-if="errors.kodeJenisIdentitas">
                            <div v-for="error in errors.kodeJenisIdentitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>




                    </div>


                </div>

            </div>


        </div>


        <div class="col-md-4 grid-margin stretch-card">

            <div class="card">

                <div class="card-body">

                    <h6 class="card-title">

                        {{ $t('ppjk') }}

                        <button v-if="forms.status == 'DRAFT'" class="btn btn-primary float-end btn-xs"
                            style="margin-right: 5px" @click.prevent="referensiPpjk()">
                            <i class="link-icon mdi mdi-book-open-page-variant"></i>
                            {{ $t("referensi") }}
                        </button>


                    </h6>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('nomor_identitas') }} </label>


                        <div class="row">

                            <div class="col-sm-6">


                                <v-select :options="fetchTipeIdentitas" v-model="ppjkTipeIdentitas" label="label"
                                    return-object @input="(country) => updatePpjkTipeIdentitas(country)">
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>

                                <div v-if="this.ppjkTipeIdentitas == null || this.ppjkTipeIdentitas?.code == ''">
                                    <div class="alert alert-danger" style="padding:5px;"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        Jenis Entitas Kosong
                                    </div>
                                </div>


                                <div v-if="errors.kodeJenisIdentitas">
                                    <div v-for="error in errors.kodeJenisIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-6">

                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    @input="forceUpper($event, entitasPpjk, 'nomorIdentitas')"
                                    v-model="entitasPpjk.nomorIdentitas" maxlength="50" required>

                                    <div v-if="this.entitasPpjk.nomorIdentitas == null || this.entitasPpjk?.nomorIdentitas == ''">
                                        <div class="alert alert-danger" style="padding:5px;"
                                            role="alert">
                                            <i data-feather="alert-circle"></i>
                                            Nomor Entitas Kosong
                                        </div>
                                    </div>

                                <div v-if="errors.nomorIdentitas">
                                    <div v-for="error in errors.nomorIdentitas" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>

                            </div>

                        </div>




                    </div>


                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('name') }} </label>


                        <input type="text" class="form-control" :id="this.$dynamicId()"
                            @input="forceUpper($event, entitasPpjk, 'namaEntitas')" v-model="entitasPpjk.namaEntitas"
                            maxlength="255" required>

                            <div v-if="this.entitasPpjk.namaEntitas == null || this.entitasPpjk?.namaEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Nama Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.namaEntitas">
                            <div v-for="error in errors.namaEntitas" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>

                    <div class="mb-3">

                        <label for="defaultconfig" class="col-form-label required"> {{ $t('alamat') }} </label>


                        <textarea required class="form-control" :id="this.$dynamicId()" :placeholder="$t('alamat')"
                            v-model="entitasPpjk.alamatEntitas" @input="forceUpper($event, entitasPpjk, 'alamatEntitas')"
                            rows="3"></textarea>

                            <div v-if="this.entitasPpjk.alamatEntitas == null || this.entitasPpjk?.alamatEntitas == ''">
                                <div class="alert alert-danger" style="padding:5px;"
                                    role="alert">
                                    <i data-feather="alert-circle"></i>
                                    Alamat Entitas Kosong
                                </div>
                            </div>

                        <div v-if="errors.alamatEntitas">
                            <div v-for="error in errors.alamatEntitas" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                            </div>
                        </div>


                    </div>




                </div>

            </div>


        </div>




        <div class="col-md-12">

            <a class="nav-link" id="entitas-line-tab" data-toggle="tab" href="#entitas" role="tab" aria-controls="disabled"
                aria-selected="false">
                <button class="btn btn-info float-end btn-sm" @click="simpanEntitas()" type="button" :disabled="isLoading">
                    <div v-show="isLoading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Loading...
                    </div>
                    <div v-show="!isLoading">
                        <i class="link-icon mdi mdi-content-save"></i>
                        {{ $t("save_change_txt") + " " + $t('entitas') }}
                    </div>
                </button>
            </a>

        </div>


        <modalReferensiImportir @setValue="setImportirValue"></modalReferensiImportir>
        <modalReferensiPemilikBarang @setValue="setPemilikBarangValue"></modalReferensiPemilikBarang>
        <modalReferensiPengirim @setValue="setPengirimValue"></modalReferensiPengirim>
        <modalReferensiPpjk @setValue="setPpjpValue"></modalReferensiPpjk>
        <modalReferensiPenjual @setValue="setPenjualValue"></modalReferensiPenjual>
    </div>
</template>

<script>
import modalReferensiImportir from "@/components/exim/ceisa/barang_impor/modal/modalReferensiImportir.vue";
import modalReferensiPemilikBarang from "@/components/exim/ceisa/barang_impor/modal/modalReferensiPemilikBarang.vue";
import modalReferensiPengirim from "@/components/exim/ceisa/barang_impor/modal/modalReferensiPengirim.vue";
import modalReferensiPpjk from "@/components/exim/ceisa/barang_impor/modal/modalReferensiPpjk.vue";
import modalReferensiPenjual from "@/components/exim/ceisa/barang_impor/modal/modalReferensiPenjual.vue";
export default {

    name: "CeisaEntitas",
    components: {
        modalReferensiImportir,
        modalReferensiPemilikBarang,
        modalReferensiPengirim,
        modalReferensiPpjk,
        modalReferensiPenjual,
    },
    props: {
        propsData: { type: [Object, Array] }
    },
    data() {
        return {
            forms: [],
            fetchTipeIdentitas: [],
            importirTipeIdentitas: { code: "", name: "", label: "" },
            isLoading:false,
            entitasImportir: {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "1",
                namaKodeEntitas: "",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: "",
                namaJenisIdentitas: "",
                namaEntitas: "",
                alamatEntitas: "",
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: "",
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            },
            fetchkodeJenisApi: [],
            errors: [],

            fetchstatusImportir: [],
            importirkodeStatus: { code: "" },

            pemilikBarangTipeIdentitas: { code: "", name: "", label: "" },

            entitasPemilikBarang: {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "7",
                namaKodeEntitas: "",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: "",
                namaJenisIdentitas: "",
                namaEntitas: "",
                alamatEntitas: "",
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: "",
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            },
            npwpPemusatanTipeIdentitas: { code: "", name: "", label: "" },
            entitasNpwpPemusatan: {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "11",
                namaKodeEntitas: "",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: "",
                namaJenisIdentitas: "",
                namaEntitas: "",
                alamatEntitas: "",
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: "",
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            },

            fetchkodeNegara: [],
            negaraPengirim: { code: "", name: "", label: "" },
            entitasPengirim: {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "9",
                namaKodeEntitas: "",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: "",
                namaJenisIdentitas: "",
                namaEntitas: "",
                alamatEntitas: "",
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: "",
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            },
            negaraPenjual: { code: "", name: "", label: "" },
            entitasPenjual: {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "",
                namaKodeEntitas: "10",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: "",
                namaJenisIdentitas: "",
                namaEntitas: "",
                alamatEntitas: "",
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: "",
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            },
            ppjkTipeIdentitas: { code: "", name: "", label: "" },
            entitasPpjk: {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "",
                namaKodeEntitas: "4",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: "",
                namaJenisIdentitas: "",
                namaEntitas: "",
                alamatEntitas: "",
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: "",
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            },
            importirkodeJenisApi: { code: "", name: "", label: "" },


        }
    },
    methods: {
        updateImportirkodeStatus(data) {
            if(data){
                this.entitasImportir.kodeStatus = data.code
            }else{
                this.entitasImportir.kodeStatus = ""
            }

        },
        updateImportirkodeJenisApi(data) {
            if(data){
                this.entitasImportir.kodeJenisApi = data.code
                this.entitasImportir.namaKodeJenisApi = data.name
            }else{   
                this.entitasImportir.kodeJenisApi = ""
                this.entitasImportir.namaKodeJenisApi = ""
            }

        },
        updateImportirTipeIdentitas(data) {
            if(data){

                this.entitasImportir.kodeJenisIdentitas = data.code
                this.entitasImportir.namaJenisIdentitas = data.name
            }else{
                this.entitasImportir.kodeJenisIdentitas = ""
                this.entitasImportir.namaJenisIdentitas = ""

            }

        },
        referensiImportir() {
            this.$modal.show('referensiImportir');
        },
        referensiPemilikBarang() {
            this.$modal.show('referensiPemilikBarang')
        },
        referensiPengirim() {
            this.$modal.show('referensiPengirim')
        },
        referensiPpjk() {
            this.$modal.show('referensiPpjk')
        },
        referensiPenjual() {
            this.$modal.show('referensiPenjual')
        },
        setImportirValue(data) {
            this.importirkodeStatus.code = data.status;

            this.importirkodeJenisApi = { code: data.type_api, name: data.type_api_name, label: data.type_api + " - " + data.type_api_name }
            this.importirTipeIdentitas = { code: data.type_identity, name: data.type_identity_name, label: data.type_identity + " - " + data.type_identity_name }

            this.entitasImportir = {
                kodeEntitas: "1",
                namaKodeEntitas: "IMPORTIR",
                kodeJenisApi: data.type_api,
                namaKodeJenisApi: data.type_api_name,
                kodeJenisIdentitas: data.type_identity,
                namaJenisIdentitas: data.type_identity_name,
                namaEntitas: data.name,
                alamatEntitas: data.address,
                kodeStatus: data.status,
                nibEntitas: data.nib,
                nomorIdentitas: data.identity_number,
                seriEntitas: "",
                created_at: "",
                updated_at: "",
            };
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
        simpanEntitas() {

            this.isLoading = true;
            var sendData = {
                document_id: this.forms.document_id,
                ppjk_id: this.forms.ppjk_id,
                ppjk_nama: this.forms.ppjk_nama,
                ppjk_alamat: this.forms.ppjk_alamat,
                ppjk_no_npwp: this.forms.ppjk_no_npwp,
                ppjk_np_ppjk: this.forms.ppjk_np_ppjk,
                entitasImportir: this.entitasImportir,
                entitasPemilikBarang: this.entitasPemilikBarang,
                entitasNpwpPemusatan: this.entitasNpwpPemusatan,
                entitasPengirim: this.entitasPengirim,
                entitasPenjual: this.entitasPenjual,
                entitasPpjk: this.entitasPpjk,
            }

            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-3";
            this.$http.post(baseURI, sendData, { timeout: 10000 }).then((response) => {
                if (response.data.status === 200) {
                    this.loading();
                    this.errors = [];
                    this.success('Berhasil');
                } else {
                    this.loading();
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.loading();
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
            });


        },
        reAssignValue() {
            var entitas = this.forms.entitas;
            if (entitas) {
                if (entitas.length > 0) {


                    for (var x = 0; x < entitas.length; x++) {

                        var ob = entitas[x];
                        if (ob.kodeEntitas == "1") {
                            this.entitasImportir = ob;
                            this.importirkodeStatus.code = ob.kodeStatus
                            this.importirTipeIdentitas = { code: ob.kodeJenisIdentitas, name: ob.namaJenisIdentitas, label: ob.kodeJenisIdentitas + " - " + ob.namaJenisIdentitas }
                            this.importirkodeJenisApi = { code: ob.kodeJenisApi, name: ob.namaKodeJenisApi, label: ob.kodeJenisApi + " - " + ob.namaKodeJenisApi }
                        }
                        if (ob.kodeEntitas == "7") {
                            this.entitasPemilikBarang = ob;
                            this.pemilikBarangTipeIdentitas = { code: ob.kodeJenisIdentitas, name: ob.namaJenisIdentitas, label: ob.kodeJenisIdentitas + " - " + ob.namaJenisIdentitas }
                        }
                        if (ob.kodeEntitas == "11") {
                            this.entitasNpwpPemusatan = ob;
                            this.npwpPemusatanTipeIdentitas = { code: ob.kodeJenisIdentitas, name: ob.namaJenisIdentitas, label: ob.kodeJenisIdentitas + " - " + ob.namaJenisIdentitas }
                        }

                        if (ob.kodeEntitas == "9") {
                            this.entitasPengirim = ob;
                            this.negaraPengirim = { code: ob.kodeNegara, name: ob.namaNegara, label: ob.kodeNegara + " - " + ob.namaNegara }
                        }
                        if (ob.kodeEntitas == "10") {
                            this.entitasPenjual = ob;
                            this.negaraPenjual = { code: ob.kodeNegara, name: ob.namaNegara, label: ob.kodeNegara + " - " + ob.namaNegara }
                        }
                        if (ob.kodeEntitas == "4") {
                            this.entitasPpjk = ob;
                            this.ppjkTipeIdentitas = { code: ob.kodeEntitas, name: ob.namaKodeEntitas, label: ob.kodeEntitas + " - " + ob.namaKodeEntitas }
                        }

                    }

                }
            }
        },
        updateNpwpPemusatanTipeIdentitas(data) {
            if(data){
                this.entitasNpwpPemusatan.kodeJenisIdentitas = data.code
                this.entitasNpwpPemusatan.namaJenisIdentitas = data.name
            }else{
                this.entitasNpwpPemusatan.kodeJenisIdentitas = ""
                this.entitasNpwpPemusatan.namaJenisIdentitas = ""
            }

        },
        setPemilikBarangValue(data) {
            this.pemilikBarangTipeIdentitas = { code: data.type_identity, name: data.type_identity_name, label: data.type_identity + " - " + data.type_identity_name }

            this.entitasPemilikBarang = {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "7",
                namaKodeEntitas: "PEMILIK",
                kodeJenisApi: data.type_api,
                namaKodeJenisApi: data.type_api_name,
                kodeJenisIdentitas: data.type_identity,
                namaJenisIdentitas: data.type_identity_name,
                namaEntitas: data.name,
                alamatEntitas: data.address,
                kodeStatus: data.status,
                nibEntitas: data.nib,
                nomorIdentitas: data.identity_number,
                seriEntitas: "",
                kodeNegara: data.country_code,
                namaNegara: data.country,
                created_at: "",
                updated_at: "",
            };
        },
        copyImportirToNpwpPemusatan() {

            this.npwpPemusatanTipeIdentitas = this.importirTipeIdentitas
            var importir = Object.assign({}, this.entitasImportir);
            this.entitasNpwpPemusatan = importir;
            this.entitasNpwpPemusatan.kodeEntitas = "11"
            this.entitasNpwpPemusatan.namaKodeEntitas = "PEMUSATAN"

        },
        copyPengirimToPenjual() {

            this.negaraPenjual = this.negaraPengirim

            this.entitasPenjual = {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "10",
                namaKodeEntitas: "PENJUAL",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: this.entitasPengirim.kodeJenisIdentitas,
                namaJenisIdentitas: this.entitasPengirim.namaJenisIdentitas,
                namaEntitas: this.entitasPengirim.namaEntitas,
                alamatEntitas: this.entitasPengirim.alamatEntitas,
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: this.entitasPengirim.nomorIdentitas,
                seriEntitas: "",
                kodeNegara: this.entitasPengirim.kodeNegara,
                namaNegara: this.entitasPengirim.namaNegara,
                created_at: "",
                updated_at: "",
            }

        },
        updatePemilikBarangTipeIdentitas(data) {
            if(data){
                this.entitasPemilikBarang.kodeJenisIdentitas = data.code
                this.entitasPemilikBarang.namaJenisIdentitas = data.name
            }else{
                this.entitasPemilikBarang.kodeJenisIdentitas = ""
                this.entitasPemilikBarang.namaJenisIdentitas = ""
            }

        },
        updateNegaraPenjual(data) {
            if(data){
                this.entitasPenjual.kodeNegara = data.code
                this.entitasPenjual.namaNegara = data.name
            }else{
                this.entitasPenjual.kodeNegara = ""
                this.entitasPenjual.namaNegara = ""
            }

        },

        updateNegaraPengirim(data) {
            if(data){
                this.entitasPengirim.kodeNegara = data.code
                this.entitasPengirim.namaNegara = data.name
            }else{
                this.entitasPengirim.kodeNegara = ""
                this.entitasPengirim.namaNegara = ""
            }

        },
        updatePpjkTipeIdentitas(data) {
            if(data){
                this.entitasPpjk.kodeJenisIdentitas = data.code
                this.entitasPpjk.namaJenisIdentitas = data.name
            }else{
                this.entitasPpjk.kodeJenisIdentitas = ""
                this.entitasPpjk.namaJenisIdentitas = ""
            }

        },


        copyImportirToPemilikBarang() {

            this.pemilikBarangTipeIdentitas = this.importirTipeIdentitas
            var importir = Object.assign({}, this.entitasImportir);
            this.entitasPemilikBarang = importir;
            this.entitasPemilikBarang.kodeEntitas = "7";
            this.entitasPemilikBarang.namaKodeEntitas = "PEMILIK";
        },
        setPengirimValue(data) {
            console.log(data);
            this.negaraPengirim = { code: data.country_code, name: data.country, label: data.country_code + " - " + data.country }

            this.entitasPengirim = {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "9",
                namaKodeEntitas: "PENGIRIM",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: data.kodeJenisIdentitas,
                namaJenisIdentitas: data.namaJenisIdentitas,
                namaEntitas: data.name,
                alamatEntitas: data.address,
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: data.identity_number,
                seriEntitas: "",
                kodeNegara: data.country_code,
                namaNegara: data.country,
                created_at: "",
                updated_at: "",
            };
        },
        setPenjualValue(data){
            console.log(data);
            this.negaraPenjual = { code: data.country_code, name: data.country, label: data.country_code + " - " + data.country }

            this.entitasPenjual = {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "10",
                namaKodeEntitas: "PENJUAL",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: data.kodeJenisIdentitas,
                namaJenisIdentitas: data.namaJenisIdentitas,
                namaEntitas: data.name,
                alamatEntitas: data.address,
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: data.identity_number,
                seriEntitas: "",
                kodeNegara: data.country_code,
                namaNegara: data.country,
                created_at: "",
                updated_at: "",
            }; 
        },
        forceUpper(e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        setPpjpValue(data) {
            this.ppjkTipeIdentitas = { code: data.kodeJenisIdentitas, name: data.namaJenisIdentitas, label: data.kodeJenisIdentitas + " - " + data.namaJenisIdentitas }

            this.entitasPpjk = {
                document_entitas_id: "",
                document_id: "",
                kodeEntitas: "4",
                namaKodeEntitas: "PPJK",
                kodeJenisApi: "",
                namaKodeJenisApi: "",
                kodeJenisIdentitas: data.kodeJenisIdentitas,
                namaJenisIdentitas: data.namaJenisIdentitas,
                namaEntitas: data.nama,
                alamatEntitas: data.alamat,
                kodeStatus: "",
                nibEntitas: "",
                nomorIdentitas: data.no_npwp,
                seriEntitas: "",
                kodeNegara: data.country_code,
                namaNegara: data.country,
                created_at: "",
                updated_at: "",

            };

            this.forms.ppjk_id = data.ppjk_id;
            this.forms.ppjk_nama = data.nama;
            this.forms.ppjk_alamat = data.alamat;
            this.forms.ppjk_no_npwp = data.no_npwp;
            this.forms.ppjk_np_ppjk = data.np_ppjk;
        },
        asyncTipeIdentitas() {

            this.fetchTipeIdentitas = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeJenisIdentitas&status=ACTIVE&sort_field=code&sort_type=ASC&limit=1000";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchTipeIdentitas.push(md);
                        }

                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },

        asynckodeJenisApi() {

            this.fetchkodeJenisApi = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeJenisApi&status=ACTIVE&sort_field=code&sort_type=ASC&limit=10";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeJenisApi.push(md);
                        }

                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },
        asyncstatusImportir() {

            this.fetchstatusImportir = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=3&page=1&type=statusImportir";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {


                    this.fetchstatusImportir = response.data.datas.data;


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asynckodeNegara() {

            this.fetchkodeNegara = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeNegara&status=ACTIVE&sort_field=code&sort_type=ASC&limit=500";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchkodeNegara.push(md);
                        }

                    }


                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });

        },
    },
    watch: {
        propsData: function (newVal) {
            this.forms = newVal;
            this.reAssignValue();

        },
        forms: function (newVal) {
            this.$emit('formUpdate', newVal);
        },
    },
    created() {
        this.asyncTipeIdentitas();
        this.asynckodeJenisApi();
        this.asyncstatusImportir();
        this.asynckodeNegara();
    }

}
</script>

<style></style>